import { render, staticRenderFns } from "./ManifestMediaWrapper.vue?vue&type=template&id=5fafd15f&scoped=true&"
import script from "./ManifestMediaWrapper.vue?vue&type=script&lang=js&"
export * from "./ManifestMediaWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fafd15f",
  null
  
)

export default component.exports